import styled from "styled-components";
import { theme } from "ui";

export const SubCategoriesContainer = styled.section`
  background-color: ${theme.colors.neutral.white};
`;

export const SubCategoriesHeader = styled.header`
  display: flex;
  align-items: center;
  gap: ${theme.space.x2};
  padding: ${theme.space.x2} ${theme.space.x4};
  border-bottom: 1px solid ${theme.colors.neutral["150"]};
  cursor: pointer;
`;

export const SubCategoriesTitle = styled.h2`
  font-size: ${theme.typography.fontSize.sm.x5};
  font-weight: ${theme.typography.fontWeight["500"]};
  color: ${theme.colors.neutral["999"]};
`;

export const CategoryContainer = styled.div`
  border-bottom: 1px solid ${theme.colors.neutral["150"]};
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: ${theme.space.x2} ${theme.space.x4};
  cursor: pointer;
`;

export const CategoryTitle = styled.span`
  color: ${theme.colors.neutral["345"]};
  font-size: ${theme.typography.fontSize.sm.x5};
  font-weight: ${theme.typography.fontWeight["400"]};
`;

export const SeeAll = styled.div`
  border-bottom: 1px solid ${theme.colors.neutral["150"]};
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: ${theme.space.x2} ${theme.space.x4};
  cursor: pointer;

  ${CategoryTitle} {
    color: ${theme.colors.primary["150"]};
  }
`;
